(ns iris.events
  (:require
   [re-frame.core :as re-frame]
   [iris.db :as db]
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [ajax.core :as ajax]
   [iris.utils :as utils]
   [iris.localstorage :as localstorage]
   [iris.cookie]
   [iris.globals :as globals]
   [goog.crypt.base64 :as b64]))



;; ;; 1. Define a global interceptor
;; (def log-every-event
;;   (re-frame/->interceptor
;;     :id :log-every-event
;;     :before (fn [context]
;;               (let [event (get-in context [:coeffects :event])]
;;                 (js/console.log "Intercepted event:" (clj->js event)))
;;               context)))

;; ;; 2. Register the interceptor globally
;; (re-frame/reg-global-interceptor log-every-event)







(re-frame/reg-event-db
 ::initialize-db
 (fn-traced [_ _]
            db/default-db))

(re-frame/reg-event-fx
 ::navigate
 (fn-traced [_ [_ handler]]
            {:navigate handler}))

(re-frame/reg-event-fx
 ::route-to
 (fn-traced [_ [_ route-str]]
            {:route-to route-str}))


(re-frame/reg-event-fx
 ::route-to-replace
 (fn-traced [_ [_ route-str]]
            {:route-to-replace route-str}))


(re-frame/reg-event-fx
 ::set-active-panel
 (fn-traced [{:keys [db]} [_ active-panel]]
            {:db (assoc db :active-panel active-panel)
             ;;  :dispatch [::rp/set-keydown-rules
             ;;             {:event-keys [[[::set-re-pressed-example "Hello, world!"]
             ;;                            [{:keyCode 72} ;; h
             ;;                             {:keyCode 69} ;; e
             ;;                             {:keyCode 76} ;; l
             ;;                             {:keyCode 76} ;; l
             ;;                             {:keyCode 79}]]] ;; o

             ;;              :clear-keys
             ;;              [[{:keyCode 27}]]}]
             }));; escape

(defn route-navigation-key [route-data]
  (let [route (:route route-data)]
    {:panel (:panel route-data)
     :handler (:handler route)
     :route-params (or (:route-params route) {})
     :query-params (or (:query-params route) {})
     :anchor-params (:anchor-params route)}))

(def major-ui-surfaces
  #{:side-panel
    :mobile-navbar-menu
    :search-bar
    :thread-alerts-popup
    :message-bar-expanded})

(def desktop-incompatible-surfaces
  {:message-bar-expanded #{:side-panel :search-bar :thread-alerts-popup}
   :side-panel #{:message-bar-expanded :search-bar}
   :search-bar #{:message-bar-expanded :side-panel :thread-alerts-popup}
   :thread-alerts-popup #{:message-bar-expanded :search-bar}})

(defn mobile-viewport?
  [db]
  (let [viewport-x (get-in db [:viewport-size :x])]
    (and (number? viewport-x) (< viewport-x 768))))

(defn open-ui-surfaces
  [db]
  (get-in db [:ui-surfaces :open] #{}))

(defn incompatible-ui-surfaces
  [db surface]
  (if (mobile-viewport? db)
    (disj major-ui-surfaces surface)
    (get desktop-incompatible-surfaces surface #{})))

(defn close-ui-surface
  [db surface]
  (cond-> (update-in db [:ui-surfaces :open] (fnil disj #{}) surface)
    (= surface :message-bar-expanded)
    (-> (assoc-in [:message-bar :mode] :latest)
        (assoc-in [:message-bar :expanded?] false))))

(defn close-ui-surfaces
  [db surfaces]
  (reduce close-ui-surface db surfaces))

(defn open-ui-surface
  [db surface]
  (-> db
      (close-ui-surfaces (incompatible-ui-surfaces db surface))
      (update-in [:ui-surfaces :open] (fnil conj #{}) surface)
      (cond->
       (= surface :message-bar-expanded)
       (-> (assoc-in [:message-bar :mode] :all)
           (assoc-in [:message-bar :expanded?] true)))))

(defn toggle-ui-surface
  [db surface]
  (if (contains? (open-ui-surfaces db) surface)
    (close-ui-surface db surface)
    (open-ui-surface db surface)))

(defn close-route-ui-surfaces
  [db]
  (close-ui-surfaces db major-ui-surfaces))

(defn collapse-side-panel-on-mobile-route-change?
  [db route]
  (and (mobile-viewport? db)
         (contains? (open-ui-surfaces db) :side-panel)
         (not= (route-navigation-key (:route db))
               (route-navigation-key route))))

(defn close-surfaces-on-route-change?
  [db route]
  (and (mobile-viewport? db)
       (seq (open-ui-surfaces db))
       (not= (route-navigation-key (:route db))
             (route-navigation-key route))))

(defn apply-route-ui-side-effects
  [new-db old-db route]
  (cond-> new-db
    (close-surfaces-on-route-change? old-db route)
    close-route-ui-surfaces))

(re-frame/reg-event-fx
 ::set-route
 (fn-traced [{:keys [db]} [_ route]]
            (let [prev-route (:route db)
                  route-rev (inc (or (:route-rev db) 0))
                  route-with-rev (assoc route :route-rev route-rev)]
              ;; {:db (assoc db :route route)}
              {:db (-> db
                       (assoc :route route-with-rev)
                       (assoc :prev-route prev-route)
                       (assoc :route-rev route-rev)
                       (apply-route-ui-side-effects db route))
               :sync-route-data-and-scroll route-with-rev})))


(re-frame/reg-event-db
 ::set-re-pressed-example
 (fn [db [_ value]]
   (assoc db :re-pressed-example value)))



;; (re-frame/reg-event-db
;;  ::get-jwt-success
;;  (fn [db [_ data]]
;;    (println "jwt::" data)
;;    (assoc-in db [:jwt] data)))

;; (re-frame/reg-event-db
;;  ::get-jwt-failure
;;  (fn [db]
;;    (println "get jwt failure")
;;    (assoc-in db [:censors :message] "Get JWT failure!")))


;; (re-frame/reg-event-fx
;;  ::get-jwt
;;  (fn [e [_]]
;;    {:http-xhrio {:method          :get
;;                  :uri             (str (. js/location -origin) "/get-jwt")
;;                  :timeout         8000                                           ;; optional see API docs
;;                  :response-format (ajax/text-response-format)  ;; IMPORTANT!: You must provide this.
;;                  :on-success      [::get-jwt-success]
;;                  :on-failure      [::get-jwt-failure]}}))

(re-frame/reg-event-db
 ::set-mobile
 (fn [db [_ mobile]]
   (assoc db :mobile mobile)))

(re-frame/reg-event-db
 ::set-viewport-size
 (fn [db [_ x y]]
   (assoc db :viewport-size {:x x :y y})))

(def navbar-collapse-scroll-top 40)
(def navbar-expand-scroll-top 8)

(defn navbar-scrolled-after-scroll
  [scrolled? scroll-top]
  (cond
    (>= scroll-top navbar-collapse-scroll-top) true
    (<= scroll-top navbar-expand-scroll-top) false
    :else (true? scrolled?)))

(re-frame/reg-event-db
 ::set-scroll-top
 (fn [db [_ value]]
   (assoc db
          :scroll-top value
          :navbar-scrolled? (navbar-scrolled-after-scroll
                              (:navbar-scrolled? db)
                              value))))

(re-frame/reg-event-db
 ::set-fp
 (fn [db [_ value]]
 (println "::set-fp" value)
   (assoc db :fp value)))

(re-frame/reg-event-db
 ::set-dfp
 (fn [db [_ value]]
   (assoc db :dfp value)))

(re-frame/reg-event-db
 ::set-loading
 (fn [db [_ value]]
   (assoc db :loading value)))

(def theme-storage-key "iris.ui.theme")
(def dark-theme-depth-storage-key "iris.ui.dark-theme-depth")

(defn valid-theme [theme]
  (if (= theme :dark) :dark :light))

(defn valid-dark-theme-depth [depth]
  (let [depth (cond
                (number? depth) depth
                (string? depth) (js/parseInt depth 10)
                :else 0)]
    (if (contains? #{-2 -1 0 1 2} depth)
      depth
      0)))

(defn clear-document-theme-class! []
  (.. js/document -body -classList (remove "iris-theme-dark")))

(re-frame/reg-fx
 :persist-theme
 (fn [theme]
   (localstorage/set-item! theme-storage-key (name (valid-theme theme)))))

(re-frame/reg-fx
 :persist-dark-theme-depth
 (fn [depth]
   (localstorage/set-item! dark-theme-depth-storage-key (str (valid-dark-theme-depth depth)))))

(re-frame/reg-fx
 :clear-document-theme
 (fn [_]
   (clear-document-theme-class!)))

(re-frame/reg-event-fx
 ::set-theme
 (fn [{:keys [db]} [_ theme]]
   (let [theme (valid-theme theme)]
     {:db (assoc db :theme theme)
      :persist-theme theme
      :clear-document-theme nil})))

(re-frame/reg-event-fx
 ::set-dark-theme-depth
 (fn [{:keys [db]} [_ depth]]
   (let [depth (valid-dark-theme-depth depth)]
     {:db (assoc db :dark-theme-depth depth)
      :persist-dark-theme-depth depth})))

(re-frame/reg-event-fx
 ::toggle-theme
 (fn [{:keys [db]} _]
   (let [theme (if (= (:theme db) :dark) :light :dark)]
     {:db (assoc db :theme theme)
      :persist-theme theme
      :clear-document-theme nil})))

(re-frame/reg-event-db
 ::set-jwt-payload
 (fn [db [_ value]]
   (assoc db :jwt-payload value)))

(re-frame/reg-event-db
 ::set-fb-user
 (fn [db [_ value]]
   (assoc db :fb-user value)))

(re-frame/reg-event-db
 ::set-fb-auth-state
 (fn [db [_ value]]
   ;;  NOTE: if nil and new value is false, leave as is.
   ;;  used for displaying fb signed out message
   ;;  onAuthChange first reports false then true
   (if (and (nil? (:fb-auth-state db)) (false? value))
     db
     (assoc db :fb-auth-state value))))

(re-frame/reg-event-db
 ::set-raids-cache-id
 (fn [db [_ value]]
   (assoc db :raids-cache-id value)))

(re-frame/reg-event-db
 ::set-raidpurger
 (fn [db [_ value]]
   (assoc db :raidpurger value)))

(re-frame/reg-event-db
 ::set-raid-len
 (fn [db [_ value]]
   (assoc db :raid-len value)))

(re-frame/reg-event-db
 ::set-roles
 (fn [db [_ value]]
   (assoc db :roles value)))

;; (re-frame/reg-event-db
;;  ::track-request
;;  (fn [db [_ id xhrio]]
;;    (println "from ::track-request" id xhrio)
;;    (when-let [rq (get-in db [:requests id])]
;;      (ajax/abort rq))
;;    (assoc-in db [:requests id] xhrio)))
(re-frame/reg-event-db
 ::track-request
 (fn [db [_ id xhrio]]
   db))

(defn now-ms []
  (.getTime (js/Date.)))

(defn request-id
  [label]
  (str label "-" (now-ms) "-" (rand-int 100000)))

(defn request-label
  [body]
  (or (:method body) "Request"))

(defn request-message
  [status data]
  (or (get-in data [:error :message])
      (get-in data [:response :error :message])
      (get-in data [:response :message])
      (get-in data [:result :message])
      (case status
        :success "Completed."
        :failure "Failed."
        "Completed.")))

(def api-msg-keys #{:result :error :debug-message})

(defonce api-msg-options-by-event (atom {}))

(defn handler-event-id
  [handler]
  (first (vec handler)))

(defn request-api-msg-options
  [handler api-msg-options]
  (or api-msg-options
      (get @api-msg-options-by-event (handler-event-id handler))
      {}))

(defn api-msg-from-data
  ([data]
   (api-msg-from-data data {}))
  ([data {:keys [result-modifier-fn
                 error-modifier-fn
                 debug-message-modifier-fn
                 mute-keys]
          :or   {result-modifier-fn identity
                 error-modifier-fn identity
                 debug-message-modifier-fn identity
                 mute-keys #{}}}]
   (let [[k v] (utils/find-first-matching-key data api-msg-keys)]
     (when (and k (not (contains? mute-keys k)))
       (let [msg (case k
                   :result        (result-modifier-fn (:message v))
                   :error         (error-modifier-fn (:message v))
                   :debug-message (debug-message-modifier-fn v))]
         {:ts (now-ms)
          k   msg})))))

(defn request-completion-status
  [transport-status data]
  (if (or (= transport-status :failure)
          (some? (:error data))
          (some? (get-in data [:response :error])))
    :failure
    :success))

(defn manual-request-label
  [method context]
  (if (seq context)
    (str method " (" context ")")
    method))

(re-frame/reg-event-fx
 ::request-started
 (fn [{:keys [db]} [_ id request original-request-handler xhrio]]
   (let [started-request (assoc request
                                :id id
                                :status :active
                                :started-at (now-ms))
         db' (-> db
                 (update-in [:requests :active]
                            (fnil (fn [requests]
                                    (->> requests
                                         (remove #(= (:id %) id))
                                         (cons started-request)
                                         (take 100)
                                         vec))
                                  [])))]
     (cond-> {:db db'}
       (some? original-request-handler)
       (assoc :dispatch (conj (vec original-request-handler) xhrio))))))

(re-frame/reg-event-db
 ::request-completed
 (fn [db [_ id status data handler api-msg-options]]
   (let [active-request (some #(when (= (:id %) id) %) (get-in db [:requests :active]))
         api-message (api-msg-from-data data (request-api-msg-options handler api-msg-options))
         [_ api-message-text] (when (map? api-message)
                                (utils/find-first-matching-key api-message api-msg-keys))
         completed-request (assoc active-request
                                  :status status
                                  :completed-at (now-ms)
                                  :message (or api-message-text
                                               (request-message status data)))]
     (cond-> (update-in db [:requests :active]
                         (fnil (fn [requests]
                                 (->> requests
                                      (remove #(= (:id %) id))
                                      vec))
                               []))
       active-request
       (update-in [:requests :completed]
                  (fnil (fn [requests]
                          (->> requests
                               (remove #(= (:id %) id))
                               (cons completed-request)
                               (take 100)
                               vec))
                        []))))))

(re-frame/reg-event-db
 ::request-completed-clear
 (fn [db [_ id]]
   (update-in db [:requests :completed]
              (fnil (fn [requests]
                      (->> requests
                           (remove #(= (:id %) id))
                           vec))
                    []))))

(re-frame/reg-event-db
 ::request-completed-clear-all
 (fn [db _]
   (assoc-in db [:requests :completed] [])))

(defn track-manual-request-start
  ([method]
   (track-manual-request-start method nil))
  ([method context]
   (let [label (manual-request-label method context)
         id (request-id label)
         request {:label label
                  :method method
                  :transport :json-rpc}]
     (re-frame/dispatch [::request-started id request nil nil])
     id)))

(defn track-manual-request-success
  [id data]
  (re-frame/dispatch [::request-completed
                      id
                      (request-completion-status :success data)
                      data
                      nil
                      nil]))

(defn track-manual-request-failure
  [id message]
  (re-frame/dispatch [::request-completed
                      id
                      :failure
                      {:response {:message message}}
                      nil
                      nil]))

(re-frame/reg-event-db
 ::side-panel-toggle-collapsed
 (fn [db _]
   (toggle-ui-surface db :side-panel)))

(re-frame/reg-event-db
 ::side-panel-collapse
 (fn [db _]
   (close-ui-surface db :side-panel)))

(re-frame/reg-event-db
 ::side-panel-set-active-tool
 (fn [db [_ tool]]
   (-> db
       (assoc-in [:side-panel :active-tool] tool)
       (open-ui-surface :side-panel))))

(re-frame/reg-event-db
 ::side-panel-set-request-filter
 (fn [db [_ filter]]
   (assoc-in db [:side-panel :request-filter] filter)))

(re-frame/reg-event-fx
 ::rpc-success
 (fn [_ [_ request-id success-handler api-msg-options data]]
   {:fx [[:dispatch (conj (vec success-handler) data)]
         [:dispatch [::request-completed
                     request-id
                     (request-completion-status :success data)
                     data
                     success-handler
                     api-msg-options]]]}))

(re-frame/reg-event-fx
 ::rpc-failure
 (fn [_ [_ request-id failure-handler api-msg-options data]]
   {:fx [[:dispatch (conj (vec failure-handler) data)]
         [:dispatch [::request-completed
                     request-id
                     (request-completion-status :failure data)
                     data
                     failure-handler
                     api-msg-options]]]}))

(defn track-http-xhrio
  [label xhrio]
  (let [id (request-id label)
        request {:label label
                 :method label
                 :transport :http}]
    (assoc xhrio
           :on-request [::request-started id request (:on-request xhrio)]
           :on-success [::rpc-success id (:on-success xhrio) nil]
           :on-failure [::rpc-failure id (:on-failure xhrio) nil])))

;; TODO: request handler is passed as vector - this is needed in case you want to pass some parameters to the handler function. it would be best if all handlers (success, failure) would be done this way
(defn post-rpc
  ([body success-handler failure-handler]
   (post-rpc body success-handler failure-handler nil))
  ([body success-handler failure-handler request-handler]
   (post-rpc body success-handler failure-handler request-handler nil))
  ([body success-handler failure-handler request-handler api-msg-options]
   (re-frame/dispatch [::set-loading true])
   (let [jwt @globals/jwt
         json (utils/clj->json body)
         label (request-label body)
         id (request-id label)
         request {:label label
                  :method (:method body)
                  :body body
                  :transport :json-rpc}]
     {:http-xhrio {:method :post
                   ;; :uri (str (utils/get-service-url "apollo") "/rpc")
                   :uri js/apolloURL
                   :body json
                   :timeout 60000
                   :headers {"Authorization" (str "Bearer " jwt)
                             "Content-Type" "application/json; charset=UTF-8"}
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-request [::request-started id request request-handler]
                   :on-success [::rpc-success id success-handler api-msg-options]
                   :on-failure [::rpc-failure id failure-handler api-msg-options]}})))




;; track request, cancel previous
;; (re-frame/reg-event-db
;;  ::track-slow-request
;;  (fn [db [_ my-id xhrio]]
;;   ;;  (.dispose xhrio)
;;   ;;  (.log js/console xhrio)
;;    (println "rq page:" (:page my-id))
;;    (.log js/console (get-in db [:requests (:id my-id)]))
;;    (when-let [rq (get-in db [:requests (:id my-id)])]
;;     ;;  (.dispose rq)
;;     ;;  (.abort rq)
;;      (ajax/abort rq))
;;    (.log js/console (get-in db [:requests (:id my-id)]))
;;    (assoc-in db [:requests (:id my-id)] xhrio)))





;; debounce event
(defonce debounce-timeouts (atom {}))

(re-frame/reg-fx
 ::dispatch-debounce
 (fn [[id event-vec n]]
   (js/clearTimeout (@debounce-timeouts id))
   (swap! debounce-timeouts assoc id
          (js/setTimeout (fn []
                           (re-frame/dispatch event-vec)
                           (swap! debounce-timeouts dissoc id))
                         n))))




(re-frame/reg-fx
 :reset-form
 (fn [form]
   (.reset (.getElementById js/document form))))


(re-frame/reg-event-fx
 ::reset-form
 (fn-traced [_ [_ form]]
            {:reset-form form}))


;; (re-frame/reg-event-fx
;;  ::get-jwt
;;  [(re-frame/inject-cofx :cookie/get "jwt")]
;;  (fn [{:keys [db] :as cofx} [e]]
;;    (println "cofx::" (:jwt cofx))))


;; (re-frame/reg-event-fx
;;  ::validate-jwt
;;  [(re-frame/inject-cofx :cookie/get "jwt")]
;;  (fn [{:keys [db] :as cofx} [e]]
;;    (println "cofx::" (:jwt cofx))
;;    {:navigate :login}))





(re-frame/reg-event-db
 ::popup-alerts
 (fn [db [_ value]]
   (if value
     (open-ui-surface db :thread-alerts-popup)
     (close-ui-surface db :thread-alerts-popup))))

(re-frame/reg-event-db
 ::set-alerts
 (fn [db [_ value]]
   ;;  (assoc db :alerts value)
   (assoc-in db [:alerts :data] value)))

(re-frame/reg-event-db
 ::set-alerts-show-all
 (fn [db [_ value]]
   (assoc-in db [:alerts :show-all] value)))

(re-frame/reg-event-db
 ::remove-alert
 (fn [db [_ id]]
   (assoc-in db [:alerts :data] (filterv #(not= (:id %) id) (get-in db [:alerts :data])))))




(defn sync-route-data-fx
  [route]
  (when route
    [:iris.route-data.events/sync-route-data route]))


;; NOTE: "set-ws" event is a temp solution, used only by globals/exec-on-fb-sign-in from core.cljs to restore the last used (default) ws from firebase
;; In the future the idea is to raise :ws to the top most level (above :posts)
(re-frame/reg-event-fx
 ::set-ws
 (fn [{:keys [db]} [_ value]]
   (let [new-db (assoc-in db [:ws] value)]
     (cond-> {:db new-db}
       (:route new-db)
       (assoc :dispatch (sync-route-data-fx (:route new-db)))))))

;; used for firebase default ws sync, switching to local storage
(re-frame/reg-event-fx
 ::set-ws-sync
 (fn [{:keys [db]} [_ value]]
   (let [new-db (-> db
                    (assoc-in [:ws] value)
                    (assoc-in [:ws-sync] true))]
     (cond-> {:db new-db}
       (:route new-db)
       (assoc :dispatch (sync-route-data-fx (:route new-db)))))))


(re-frame/reg-event-db
 ::set-message
 (fn [db [_ value]]
   (assoc-in db [:message] value)))

(re-frame/reg-event-db
 ::toggle-show-search-bar
 (fn [db [_]]
   (toggle-ui-surface db :search-bar)))

(re-frame/reg-event-db
 ::ui-surface-open
 (fn [db [_ surface]]
   (open-ui-surface db surface)))

(re-frame/reg-event-db
 ::ui-surface-close
 (fn [db [_ surface]]
   (close-ui-surface db surface)))

(re-frame/reg-event-db
 ::ui-surface-toggle
 (fn [db [_ surface]]
   (toggle-ui-surface db surface)))

(re-frame/reg-event-db
 ::ui-surfaces-close-all
 (fn [db _]
   (close-ui-surfaces db major-ui-surfaces)))



;; # JobKws ruid -timeUpdated
;; - kind: JobKws
;;   properties:
;;   - name: ruid
;;   - name: timeUpdated
;;     direction: desc

;; 'JobKws.Get': 'get_jobkws',
;; 'JobKws.GetHistory': 'get_jobkws_history',
;; 'JobKws.Submit': 'submit_jobkws',

;;   # JobKws ---
;;   def get_jobkws(self, ruid=None):
;;       # query JobKws
;;       # filter by ruid
;;       # order by timeUpdated
;;       # return first result
;;       qry = self.ds.query_jobkws(ruid)
;;       return qry.get()

;;   def get_jobkws_history(self, ruid=None):
;;       # same as above but return all results
;;       qry = self.ds.query_jobkws(ruid)
;;       return qry.fetch()

;;   def submit_jobkws(self, ruid=None, keywords_input=None):
;;       e = JobKws(ruid=ruid, keywords_input=keywords_input)
;;       now = datetime.datetime.now()
;;       uid = self.rq.usr.uid()
;;       last = self.get_jobkws(ruid)
;;       if last:
;;           e.time_created = last.time_created
;;           e.who_created = last.who_created
;;       else:
;;           e.time_created = now
;;           e.who_created = uid
;;       e.time_updated = now
;;       e.who_updated = uid
;;       s = punct_to_spaces(e.keywords_input).strip()
;;       e.keywords_input = s
;;       if e.keywords_input:
;;           e.keywords = e.keywords_input.split()
;;       self.ds.put(e)

;; def punct_to_spaces(s):
;;   PUNCT = [',', ';']
;;   for p in PUNCT:
;;       s = s.replace(p, ' ')



(re-frame/reg-event-db
 ::http-get-job-keywords-success
 (fn [db [_ ruid data]]
   ;;  (re-frame/dispatch [::http-complete])
   (re-frame/dispatch [::set-loading false])

   (if-let [result-data (get-in data [:result :data])]
     (-> db
         (assoc-in [:job-keywords (keyword ruid)] result-data))
     db)))


(re-frame/reg-event-db
 ::http-get-job-keywords-failure
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;this will not work - this gets triggered on http fail - not not being able to pull record, we still get valid response
   (-> db
       ;;  (assoc-in [:posts :message] "API connection failure!")
       (assoc-in [:message] "API connection failure!"))))


(re-frame/reg-event-fx
 ::http-get-job-keywords
 (fn [e [_ ruid]]
   (post-rpc {:jsonrpc "2.0"
              :id 0
              :method "JobKws.Get"
              :params {:options {:debug false}
                       :data ruid}}
             [::http-get-job-keywords-success ruid]
             [::http-get-job-keywords-failure])))



(re-frame/reg-event-db
 ::http-get-job-keywords-history-success
 (fn [db [_ ruid data]]
   ;;  (re-frame/dispatch [::http-complete])
   (re-frame/dispatch [::set-loading false])

   ;;  (if-let [result-data (get-in data [:result :data])]
   (if-let [result-data (get-in data [:result :data])]
     (-> db
         (assoc-in [:job-keywords (keyword ruid)] result-data))
     db)))

(re-frame/reg-event-db
 ::http-get-job-keywords-history-failure
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;this will not work - this gets triggered on http fail - not not being able to pull record, we still get valid response
   (-> db
       ;;  (assoc-in [:posts :message] "API connection failure!")
       (assoc-in [:message] "API connection failure!"))))

(re-frame/reg-event-fx
 ::http-get-job-keywords-history
 (fn [e [_ ruid]]
   (post-rpc {:jsonrpc "2.0"
              :id 0
              :method "JobKws.GetHistory"
              :params {:options {:debug false}
                       :data ruid}}
             [::http-get-job-keywords-history-success ruid]
             [::http-get-job-keywords-history-failure])))








(re-frame/reg-event-db
 ::http-job-keywords-submit-success
 (fn [db [_ ruid data]]
   ;;  (re-frame/dispatch [::http-complete])
   (re-frame/dispatch [::set-loading false])

   (when-let [result-data (get-in data [:result :data])]
     (re-frame/dispatch [::http-get-job-keywords-history ruid]))

   (set! (.-value (.getElementById js/document "location-input")) "")
   (set! (.-value (.getElementById js/document "kws-input")) "")

   (-> db
       (assoc-in [:message] (get-in data [:result :message])))))


(re-frame/reg-event-db
 ::http-job-keywords-submit-failure
 (fn [db]
   (re-frame/dispatch [::http-complete])
   (-> db
       ;;  (assoc-in [:posts :message] "API connection failure!")
       (assoc-in [:message] "API connection failure!"))))


(re-frame/reg-event-fx
 ::http-job-keywords-submit
 (fn [e [_ ruid kws-input location-input]]
   (post-rpc {:jsonrpc "2.0"
              :id 0
              :method "JobKws.Submit"
              :params {:options {:debug false}
                       :data {:ruid ruid
                              :keywords kws-input
                              :location location-input}}}
             [::http-job-keywords-submit-success ruid]
             [::http-job-keywords-submit-failure])))


(def redo-interceptor
  (re-frame/->interceptor
   :id :redo
   :before (fn [context] ;; we take the interceptor context
             ;;  redo key - take the current route object and base64 it, assign events to be redone under it
             ;;  when the route changes, scrap the current values in atom and assign new ones under the new redo key
             (let [k (keyword (b64/encodeString (-> context :coeffects :db :route)))]
               (if-let [redo-events (k @globals/redo)]
                 (do
                   ;;  destructure the new event into event (ne) and params (np)
                   ;;  filter the already assigned events in redo atom to make sure the same event isn't already there
                   ;;  add the new event to filtered list of redo events and assign it back to atom
                   (let [[ne np] (-> context :coeffects :event)]
                     (let [filtered-redo-events (filter (fn [[e p]] (not= e ne)) redo-events)]
                       (let [new-redo-events (conj filtered-redo-events (-> context :coeffects :event))]
                         (swap! globals/redo #(assoc-in @globals/redo [k] new-redo-events))))))
                 (do
                   ;;  no redo events found under this key (k), init new redo event list
                   (swap! globals/redo #(assoc-in {} [k] (list (-> context :coeffects :event))))))
               (println "after redo-events update @globals/redo:" @globals/redo))
             context))) ;; return the context unmodified


(re-frame/reg-event-fx
 ::redo
 (fn [_ _]
   (let [redo-val @globals/redo]
     (if (empty? redo-val)
       (do
         (println "No redo events but :redo was dispatched.")
         {}) ;; return no effects
       (do
         ;; destructuring map with an unknown key
         ;; get keys (list) and return first from the list - k
         ;; use k to get the list of events to be dispatched/redone from redo atom
         (let [k (-> redo-val keys first)
               events (k @globals/redo)]
           (doseq [e events]
             (re-frame/dispatch e)))
         {}) ;; return no effects
       ))))




(defn api-msg-interceptor
  [{:keys [result-modifier-fn
           error-modifier-fn
           debug-message-modifier-fn
           mute-keys
           id]
    :or   {result-modifier-fn identity
           error-modifier-fn identity
           debug-message-modifier-fn identity
           mute-keys #{}}}]
  (let [api-msg-options {:result-modifier-fn result-modifier-fn
                         :error-modifier-fn error-modifier-fn
                         :debug-message-modifier-fn debug-message-modifier-fn
                         :mute-keys mute-keys}]
    (re-frame.core/->interceptor
   :id     (or id :api-msg-interceptor)
   :before (fn [context]
             (when-let [event-id (handler-event-id (get-in context [:coeffects :event]))]
               (swap! api-msg-options-by-event assoc event-id api-msg-options))
             ;; store the original db so it's accessible in :after (note: needed for -fx events)
             (if-let [db (get-in context [:coeffects :db])]
               (assoc-in context [:api-msg-interceptor :original-db] db)
               context))
   :after  (fn [context]
             (letfn [(set-m-in-context [context m]
                       (let [handler-db  (get-in context [:effects :db])
                             fallback-db (get-in context [:api-msg-interceptor :original-db])
                             db          (or handler-db fallback-db)]

                         (if db
                           (let [old-msgs      (get-in db [:messages])
                                 prev-msg      (first old-msgs)
                                 prev-ts       (:ts prev-msg)
                                 new-ts        (:ts m)
                                 within-3s     (and prev-ts
                                                    (<= (js/Math.abs (- new-ts prev-ts)) 3000))
                                 new-more-msgs (if within-3s
                                                 (inc (get-in db [:message-bar :more-msgs] 0))
                                                 0)
                                 updated-db    (-> db
                                                   (update :messages #(->> (cons m (or % []))
                                                                           (take globals/MESSAGES_LIMIT)
                                                                           vec))
                                                   (assoc-in [:message-bar :more-msgs] new-more-msgs)
                                                   (assoc-in [:message-bar :mode] :latest)  ;; <- added to display latest on new message arrival
                                                   (assoc-in [:message-bar :index] 0) ;; <- added to display latest on new message arrival
                                                   (close-ui-surface :message-bar-expanded))]
                             (assoc-in context [:effects :db] updated-db))
                           context)))]

               (let [event (get-in context [:coeffects :event])
                     m (api-msg-from-data event api-msg-options)]
                 (if m
                   (set-m-in-context context m)
                   context)))))))


;; (re-frame/reg-event-db
;;  ::add-msg
;;  (fn [db [_ msg]]
;;    (let [now-ts (.getTime (js/Date.))] ; Unix timestamp in ms
;;      (update-in db [:messages]
;;                 (fnil #(->> (cons (assoc msg :ts now-ts) %)
;;                             (take globals/MESSAGES_LIMIT)
;;                             vec)
;;                       [])))))


(re-frame/reg-event-db
 ::add-msg
 (fn [db [_ msg]]
   (let [now-ts (.getTime (js/Date.))
         old-msgs      (get-in db [:messages])
         prev-msg      (first old-msgs)
         prev-ts       (:ts prev-msg)
         new-ts        now-ts
         within-3s     (and prev-ts
                            (<= (js/Math.abs (- new-ts prev-ts)) 3000))
         new-more-msgs (if within-3s
                         (inc (get-in db [:message-bar :more-msgs] 0))
                         0)]
     (-> db
         (update-in [:messages]
                    (fnil #(->> (cons (assoc msg :ts now-ts) %)
                                (take globals/MESSAGES_LIMIT)
                                vec)
                          []))
         (assoc-in [:message-bar :more-msgs] new-more-msgs)
         (assoc-in [:message-bar :mode] :latest) ;; <-- added to display latest on new message arrival
         (assoc-in [:message-bar :index] 0) ;; <-- added to display latest on new message arrival
         (close-ui-surface :message-bar-expanded) ;; <-- added to display latest on new message arrival
         ))))  



;; This was an attempt to add reagent component as component key in messages, can get rid of
;; (re-frame/reg-event-db
;;  ::add-msg
;;  (fn [db [_ msg & [component]]]
;;    (let [now-ts (.getTime (js/Date.))
;;          msg-entry (cond-> (assoc msg :ts now-ts)
;;                      component (assoc :component component))]
;;      (update-in db [:messages]
;;                 (fnil #(->> (cons msg-entry %)
;;                             (take globals/MESSAGES_LIMIT)
;;                             vec)
;;                       [])))))



(re-frame/reg-event-db
 ::message-bar-set-mode
 (fn [db [_ mode]]
   (assoc-in db [:message-bar :mode] mode)))

(re-frame/reg-event-db
 ::message-bar-set-index
 (fn [db [_ idx]]
   (assoc-in db [:message-bar :index] idx)))

(re-frame/reg-event-db
 ::message-bar-set-expanded?
 (fn [db [_ val]]
   (if val
     (open-ui-surface db :message-bar-expanded)
     (close-ui-surface db :message-bar-expanded))))

(re-frame/reg-event-db
 ::message-bar-toggle-expanded?
 (fn [db _]
   (toggle-ui-surface db :message-bar-expanded)))
